export const API = {
  API_BASE:'https://api.rateometer.app/api',

  LOGIN: "auth/login",
  SEND_OTP: "auth/send-otp",
  VERIFY_EMAIL: "auth/verify-email",
  FORGOT: "auth/forgot-password",  
  CHANGE: "/auth/change-password",
  EDIT_PROFILE:"/user/edit-profile",
  ADD_ADMIN: "auth/register/admin",
  UPLOAD_PROFILE_IMAGE: "auth/upload-single",
  
  ALL_USERS: "app/user",
  EDIT_USER: "app/user",
  DELETE_USER: "app/user",
  UPLOAD_SINGLE_IMAGE: "app/upload-image",
  UPLOAD_INDUSTRY_DATA: "industry/upload-industry-averages",
  RESET_INDUSTRY_DATA: "industry/reset-industry-averages",
  REINITIATE_MODEL: "app/initiate-model",
  DELETE_IMAGE: "app/delete-image",
}